import { render, staticRenderFns } from "./StartupVideo.vue?vue&type=template&id=2fedc071&"
import script from "./StartupVideo.vue?vue&type=script&lang=js&"
export * from "./StartupVideo.vue?vue&type=script&lang=js&"
import style0 from "./StartupVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports